var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6805_4685)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.74998 12.1277L4.14748 9.52523C3.85498 9.23273 3.38248 9.23273 3.08998 9.52523C2.79748 9.81773 2.79748 10.2902 3.08998 10.5827L6.22498 13.7177C6.51748 14.0102 6.98998 14.0102 7.28248 13.7177L15.2175 5.78273C15.51 5.49023 15.51 5.01773 15.2175 4.72523C14.925 4.43273 14.4525 4.43273 14.16 4.72523L6.74998 12.1277Z",
    fill: "#00B574"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6805_4685"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.c1c1f9a10ef5fda527c653204c6d5383.svg";
export { ForwardRef as ReactComponent };